import { lazy } from 'react';

const List = lazy(() => import('pages/crud'));
const Course = lazy(() => import('pages/course'));

const courseRoutes = [
    {
        path: '/app/cursos',
        name: 'Cursos',
        component: List,
        exact: true,
        title: 'Cursos'
    },
    {
        path: '/app/cursos/novo',
        name: 'Novo curso',
        component: Course,
        exact: true,
        title: 'Novo curso'
    },
    {
        path: '/app/cursos/editar/:id',
        name: 'Editar',
        component: Course,
        exact: true,
        title: 'Editar curso'
    }
];

export default courseRoutes;
